"use client";

import * as React from "react";
import type { CarouselContextValue, SlideContextValue } from "./carousel.types";

export const CarouselContext = React.createContext<CarouselContextValue | null>(
  null,
);

/** Access the Embla ref and API from any component inside `<Carousel.Root>`. */
export function useCarousel(): CarouselContextValue {
  const ctx = React.useContext(CarouselContext);
  if (!ctx) throw new Error("useCarousel must be used within <Carousel.Root>");
  return ctx;
}

export const SlideContext = React.createContext<SlideContextValue | null>(null);

/**
 * Read the preload state of the current slide.
 * Returns `{ preload: true }` when the slide is warm (active, next, or hovered)
 * or when called outside a `<Carousel.Slide index={…}>`.
 */
export function useSlide(): SlideContextValue {
  return React.useContext(SlideContext) ?? { preload: true };
}
